$(document).on("click",".top_review_star_badge",function() {
    var header_height = $("div#mobile-header").height();
        $('html, body').animate({
        scrollTop: $("div#stamped-main-widget").offset().top - header_height - 150
    }, 1200);
});
$(document).on("click",".stamped-container .stamped-review-image a",function() {
    $("html").addClass("stampedpopup_open");
});

$(document).on("click","span.stamped-modal-close",function() {
    $("html").removeClass("stampedpopup_open");
});


$('.custom-add-btn00').on('click', function(e) {
  e.preventDefault();
  $('.product-page-btn').trigger('click');
});



